// https://www.dotnetcurry.com/aspnet-core/1480/aspnet-core-vuejs-signalr-app
import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import config from '../config'
import Vue from 'vue'
import api from '../api'

export default {
  install () {
    let urlClientHub = ''
    if (config.environment === 'Local') {
      urlClientHub = config.urlClientHubLocal
    } else if (config.environment === 'Development') {
      urlClientHub = config.urlClientHubDev
    // } else if (config.environment === 'Production') {
    //   urlClientHub = config.urlClientHubPrd
    } else {
      urlClientHub = '/clientHub'
    }

    const hubConnection = new HubConnectionBuilder()
    .withUrl(urlClientHub)
    .configureLogging(LogLevel.Information)
    .build()

    // hubConnection.serverTimeoutInMilliseconds = 1000 * 60 * 10 // 1 second * 60 * 10 = 10 minutes. https://github.com/aspnet/SignalR/issues/2668

    Object.defineProperty(WebSocket, 'OPEN', { value: 1 }) // https://stackoverflow.com/questions/55545204/websocket-is-not-in-the-open-state
    let startedPromise = null
    function start () {
      startedPromise = hubConnection.start()
        .then(function() {
          if (hubConnection.connection.transport.webSocket === undefined) {
            window.localStorage.setItem('connectionId', getParameterByName('id', hubConnection.connection.transport.url))
          } else {
            window.localStorage.setItem('connectionId', getParameterByName('id', hubConnection.connection.transport.webSocket.url))
          }

          // if (config.environment === 'Local') {
          //   window.localStorage.setItem('connectionId', getParameterByName('id', hubConnection.connection.transport.webSocket.url || hubConnection.connection.transport.url))
          // } else {
          //   window.localStorage.setItem('connectionId', getParameterByName('id', hubConnection.connection.transport.webSocket.url || hubConnection.connection.transport.url))
          // }

          let locationId = window.localStorage.getItem('locationId')
          if (locationId !== undefined && locationId !== '') {
            let checkInOutData = JSON.parse(window.localStorage.getItem('checkInOutData'))
            let connectionId = window.localStorage.getItem('connectionId')

            if (checkInOutData && connectionId) {
              checkInOutData.ClientHubId = connectionId

              let status = ''
              let message = ''
              api.request('Guest', 'post', '/api/CheckInOutLocation/Update', checkInOutData)
                .then(response => {
                  var resData = response.data
                  status = resData.returnStatus ? 'success' : 'error'
                  message = resData.returnMessage
                  this.inquiry()
                  return resData
                })
                .then(response => {
                  if (response.returnStatus) {
                    window.localStorage.setItem('locationId', checkInOutData.Name)
                    window.localStorage.setItem('checkInOutData', checkInOutData)
                  }
                })
                .catch(error => {
                  status = 'error'
                  message = 'Error happens when call API delete: ' + error.message
                })
              console.log(status)
              console.log(message)
            }
          }
        })
        .catch(err => {
          console.error('Failed to connect with hub', err)
          // return new Promise((resolve, reject) =>
          //   setTimeout(() => start().then(resolve).catch(reject), 30000))
        })
      // console.log(startedPromise)
      return startedPromise
    }

    function getParameterByName(name, url) {
      name = name.replace(/[\\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      var results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }

    hubConnection.onclose(() => start())
    start()

    // use new Vue instance as an event bus
    const clientHub = new Vue()
    // every component will use this.$clientHub to access the event bus
    Vue.prototype.$clientHub = clientHub
    // Forward server side SignalR events through $clientHub, where components will listen to them
    hubConnection.on('CheckInConfirmation', (guest, projectId, guestActivityId, detailMessage) => {
      clientHub.$emit('check-in-confirmation', { guest, projectId, guestActivityId, detailMessage })
    })
  }
}



// WEBPACK FOOTER //
// ./src/signalr/clienthub.js